export const CLIENT_TYPES = {
    AUDI: 'audi',
    BENTLEY: 'bentley',
    CUPRA: 'cupra',
    VOLKSWAGEN: 'volkswagen'
};

export const SEARCH_DEBOUNCE_VALUE = 1000;

export const MAX_DELERSHIP_GRUOPS_TO_CREATE_PLAYLIST = 5;

export const GLOBAL_COUNTRY_IRI = '/countries/XXX';

export enum SOURCE_FORMATS {
    MTT = 'mtt',
    PREVIEW = 'content_270p'
}

export const VIDEO_SOURCE_PATHS = {
    preview: ['sourceFormats', 'content_270p'],
    mtt: ['sourceFormats', 'mtt']
};

export const CLIENT_LETTERS = {
    audi: 'A',
    cupra: 'S',
    skoda: 'C',
    nutzfahrzeuge: 'N',
    man: 'M',
    bugatti: 'G',
    bentley: 'E',
    lamborghini: 'L',
    volkswagen: 'V',
    porsche: 'P'
};

export const BRAND_NAMES = {
    A: 'Audi',
    S: 'Cupra',
    C: 'Skoda',
    N: 'Nutzfahrzeuge',
    M: 'Man',
    G: 'Bugatti',
    E: 'Bentley',
    L: 'Lamborghini',
    V: 'Volkswagen',
    P: 'Porsche'
};

export const ENV_TYPES = {
    DEV: 'dev',
    INT: 'int',
    PROD: 'prod'
};

export const COLLECTION_ORDER_BY = {
    TITLE: 'title.title',
    DATE: 'createdAt'
};

export enum ORDER_BY_DIRECTION {
    ASC = 'asc',
    DESC = 'desc'
}

export const COOKIE_KEYS = {
    REFRESH_TOKEN: 'refresh_token',
    TOKEN: 'token',
    ID_TOKEN: 'id_token',
    CONTEXT_TOKEN: 'context_token'
};

export const LANGUAGES = [
    {
        code: 'en',
        name: 'English',
        country_code: 'GBR'
    },
    {
        code: 'de',
        name: 'Deutsch',
        country_code: 'DEU'
    },
    // {
    //     code: 'es',
    //     name: 'Español',
    //     country_code: 'ESP'
    // }
    // {
    //     code: 'fr',
    //     name: 'Français',
    //     country_code: 'FRA'
    // },
    // {
    //     code: 'it',
    //     name: 'Italiano',
    //     country_code: 'ITA'
    // },
    // {
    //     code: 'pt',
    //     name: 'Português',
    //     country_code: 'PRT'
    // },
    // {
    //     code: 'ru',
    //     name: 'Русский',
    //     country_code: 'RUS'
    // },
    // {
    //     code: 'ja',
    //     name: '日本語',
    //     country_code: 'JPN'
    // },
    // {
    //     code: 'ko',
    //     name: '한국어',
    //     country_code: 'KOR'
    // },
    // {
    //     code: 'zh',
    //     name: '文言',
    //     country_code: 'CHN'
    // }
];

export const REQUESTS = {
    CONTENT_TYPE: {
        JSON: 'application/json',
        JSON_LD: 'application/ld+json',
        PATCH: 'application/merge-patch+json'
    },
    ACCEPT: {
        JSON: 'application/json',
        JSON_LD: 'application/ld+json',
        JSON_VND_LD: 'application/vnd.ld+json',
        PATCH: 'application/merge-patch+json'
    },
    AUTHORIZATION_TYPE: 'Bearer'
};

export const RESPONSE = {
    ID: '@id',
    EXPAND_COLLECTION: 'hydra:member',
    TOTAL: 'hydra:totalItems',
    VIEW: 'hydra:view',
    FIRST_PAGE: ['hydra:view', 'hydra:first'],
    LAST_PAGE: ['hydra:view', 'hydra:last'],
    PREVIOUS_PAGE: ['hydra:view', 'hydra:previous'],
    CURRENT_PAGE: ['hydra:view', '@id'],
    NEXT_PAGE: ['hydra:view', 'hydra:next'],
    AGGREGATIONS: 'newretail:aggregations',
};

export const MAX_RESULTS = 10000;

export const OPTIONS_LENGTH_LIMIT = 50;

export const MEDIA_TYPES = [
    {
        label: 'video',
        value: 'video'
    },
    {
        label: 'image',
        value: 'image'
    },
    {
        label: 'audio',
        value: 'audio'
    },
    {
        label: 'document',
        value: 'document'
    }
];

export const USE_RIGHTS = [
    {
        value: 'limited',
        label: 'limited'
    },
    {
        value: 'unlimited',
        label: 'unlimited'
    }
];

export const ON_BOARDING_VIDEO_URLS = {
    audi: {
        en: [
            'https://assets.content.audi/453653/tutorials/retail-content-manager/01_-_RCM_-_Overview_EN.mp4',
            'https://assets.content.audi/453653/tutorials/retail-content-manager/02_-_RCM_-_Playlist_creation_EN.mp4',
            'https://assets.content.audi/453653/tutorials/retail-content-manager/03_-_RCM_-_Miwi_interaction_EN.mp4'

        ],
        de: [
            'https://assets.content.audi/453653/tutorials/retail-content-manager/01_-_RCM_-_Overview_DE.mp4',
            'https://assets.content.audi/453653/tutorials/retail-content-manager/02_-_RCM_-_Playlist_creation_DE.mp4',
            'https://assets.content.audi/453653/tutorials/retail-content-manager/03_-_RCM_-_Miwi_interaction_DE.mp4'
        ]
    },
    volkswagen: {
        en: [
            'https://assets.content.audi/453653/tutorials/retail-content-manager/01_-_RCM_-_Overview_EN.mp4',
            'https://assets.content.audi/453653/tutorials/retail-content-manager/02_-_RCM_-_Playlist_creation_EN.mp4',
            'https://assets.content.audi/453653/tutorials/retail-content-manager/03_-_RCM_-_Miwi_interaction_EN.mp4'
        ],
        de: [
            'https://assets.content.audi/453653/tutorials/retail-content-manager/01_-_RCM_-_Overview_DE.mp4',
            'https://assets.content.audi/453653/tutorials/retail-content-manager/02_-_RCM_-_Playlist_creation_DE.mp4',
            'https://assets.content.audi/453653/tutorials/retail-content-manager/03_-_RCM_-_Miwi_interaction_DE.mp4'
        ]
    },
    bentley: {
        en: [
            'https://assets.content.audi/453653/tutorials/retail-content-manager/01_RCM_Overview_CUPRA.mp4',
            'https://assets.content.audi/453653/tutorials/retail-content-manager/02_RCM_Playlists_CUPRA.mp4'
        ],
        de: [
            'https://assets.content.audi/453653/tutorials/retail-content-manager/01_RCM_Overview_CUPRA.mp4',
            'https://assets.content.audi/453653/tutorials/retail-content-manager/02_RCM_Playlists_CUPRA.mp4'
        ]
    },    
    cupra: {
        en: [
            'https://assets.content.audi/453653/tutorials/retail-content-manager/01_RCM_Overview_CUPRA.mp4',
            'https://assets.content.audi/453653/tutorials/retail-content-manager/02_RCM_Playlists_CUPRA.mp4'
        ],
        de: [
            'https://assets.content.audi/453653/tutorials/retail-content-manager/01_RCM_Overview_CUPRA.mp4',
            'https://assets.content.audi/453653/tutorials/retail-content-manager/02_RCM_Playlists_CUPRA.mp4'
        ]
    }
};

export const SORT_MEDIA_OPTIONS = [
    { title: 'created_desc', sort: 'order[created]', order: 'desc' }, //default
    { title: 'created_asc', sort: 'order[created]', order: 'asc' },
    { title: 'relevance_desc', sort: 'order[relevance]', order: 'desc' },
    { title: 'relevance_asc', sort: 'order[relevance]', order: 'asc' },
];

export const DEFAULT_SEARCH_PAGE_SIZE = 30;

export const MAX_MODELS_PAGE_SIZE = 1000;

export const DEFAULT_MEDIA_SORT = 'order[created]';

export const DEFAULT_MEDIA_ORDER = 'desc';

export const OVERRIDE_SISSION_DURATION = 5 * 60 * 1000;

type OrderBy = ORDER_BY_DIRECTION.ASC | ORDER_BY_DIRECTION.DESC;

export type PlaylistOrderBy =
    | {
          'order[updatedAt]': OrderBy;
      }
    | { 'order[duration]': OrderBy };

export const SORT_PLAYLIST_OPTIONS: {
    translationKey: string;
    query: PlaylistOrderBy;
}[] = [
    {
        translationKey: 'updated_desc',
        query: { 'order[updatedAt]': ORDER_BY_DIRECTION.DESC }
    },
    {
        translationKey: 'updated_asc',
        query: { 'order[updatedAt]': ORDER_BY_DIRECTION.ASC }
    },
    {
        translationKey: 'duration_desc',
        query: { 'order[duration]': ORDER_BY_DIRECTION.DESC }
    },
    {
        translationKey: 'duration_asc',
        query: { 'order[duration]': ORDER_BY_DIRECTION.ASC }
    }
];
// export const SORT_PLAYLIST_OPTIONS = [
//     { title: 'updated_desc', query: 'order[updatedAt]=desc' },
//     { title: 'updated_asc', query: 'order[updatedAt]=asc' },
//     { title: 'duration_desc', query: 'order[duration]=desc' },
//     { title: 'duration_asc', query: 'order[duration]=asc' }
// ];

export const DEFAULT_PLAYLIST_SORT_BY = '&order[updatedAt]=desc';

export enum ROUTES {
    DASHBOARD = '/dashboard',
    DEVICES = '/devices',
    PLAYLISTS = '/playlists',
    MEDIA_LIBRARY = '/media-library',
    ONBOARDING = '/onboarding',
    PROFILE = '/profile',
    FAQS = '/faqs',
    SEARCH_RESULTS = '/search-results',
    NO_AUTHENTICATED = '/',
    VIDEOS = '/videos',
    IMAGES = '/images',
    DOCUMENTS = '/documents',
    AUDIOS = '/audios',
    CONNECT = '/connect',
    GRP = '/grp',
    DEALERSHIPS = '/dealerships',
    IFRAME_WELCOME_SCREEN = '/welcome-screen',
    WELCOME_SCREEN_PAGE = '/welcome-screen-page'
}

export const RolesOptions = [
    { label: "Brand Responsible", value: "brand_responsible"},
    { label: "Market Responsible",value: "market_responsible" },
    { label: "Dealer", value: "dealer" }
]

export const MIWI_PROJECT_NAME = 'VMS RCM';

export enum DeviceClassMap {
    '2D' = 'CHROMEBOX',
    '3D' = 'AVE'
}

export enum SEARCH_RESOURCES {
    MEDIA = 'media',
    DEVICE = 'device',
    PLAYLIST = 'playlist',
    DEALERSHIP = 'dealership'
}

export enum DeviceClassOptionsMap {
    'All' = 'All',
    '2D' = 'CHROMEBOX',
    '3D' = 'AVE'
}

export const CONTEXT_RESPONSE = 'contextResponse';

export const OAUTH_USER_RESPONSE = 'oauthUserResponse';

export const AVP_LOCAL_HOST = 'http://localhost:3000';

export const AI_CLASSIFICATION =[
    { label: 'None', value: 'none' },
    { label: 'AI Generated', value: 'ai_generated' },
    { label: 'AI Modified', value: 'ai_modified' },
    { label: 'AI Assisted', value: 'ai_assisted' }
    //{ label: 'Unknown', value: 'unknown' }
];

export const AI_DISCLOSURE = [
    { label: 'Disclosure required', value: true },
    { label: 'Disclosure not required', value: false }
];

export const AI_HUMAN_REVIEWED = [
    { label: 'Yes', value: "true" },
    { label: 'No', value: "false" }
    //{ label: 'Unknown', value: 'unknown' }
];